import { LitElement, html } from "lit-element";
import { customElement, property } from "lit/decorators.js";
import GameApp from "../../index";
import { Color } from "excalibur";
import { TILE_COLORS, WALL_COLORS, WALL_PATTERNS } from "@/config";
import "./chat-history";
import { hasRole } from "@/utils/permission";
import Location from "@/scenes/location";
import { ModalScreen } from "./modal-screen";
@customElement("location-info")
export class LocationInfo extends LitElement {
  @property({ type: Number }) id: any = null;
  @property({ type: String }) thumbnailUrl = "";
  @property({ type: String }) title = "Default Title"; // Added property for title
  @property({ type: String }) owner = "Default Owner"; // Added property for owner
  @property({ type: Boolean }) isEditing = false; // To toggle between info and edit mode
  @property({ type: Array }) wallColors = WALL_COLORS;
  @property({ type: Array }) tileColors = TILE_COLORS;
  @property({ type: String }) selectedWallColor = WALL_COLORS[0]; // Default selected wall color
  selectedTileColor: any = TILE_COLORS[0];
  ownerId: number;
  @property({ type: Number }) usersInRoom: number = 0;
  roomId: any;

  constructor() {
    super();
    this.title = "Default Title";
    this.owner = "Default Owner";
  }

  protected createRenderRoot() {
    return this;
  }

  // Method to set title
  setTitle(newTitle: string) {
    this.title = newTitle;
  }

  // Method to set owner
  setOwner(newOwner: { roomId: any; userId: number; username: string }) {
    this.roomId = newOwner?.roomId;
    this.ownerId = newOwner?.userId;
    this.owner = newOwner?.username;
  }

  // Toggle edit mode
  openEditMode() {
    this.isEditing = !this.isEditing;
  }

  openRoomSettings() {
    const roomSetting = document.querySelector("room-settings") as ModalScreen;
    roomSetting?.openModal(this.roomId);
  }

  // Method to change wall color
  setWallColor(color: string) {
    this.selectedWallColor = color;

    const scene = GameApp.game.currentScene as Location;
    scene.roomTileMap.changeTopWallColor(Color.fromHex(color));
  }

  async setWallPattern(pattern: string) {
    // GlobalPartySocket.sendMessage(
    //   JSON.stringify({
    //     type: "command",
    //     command: "location-actions",
    //     args: { action: "wall-update", value: pattern },
    //   })
    // );
  }

  setTileColor(color: string) {
    this.selectedTileColor = color;

    const scene = GameApp.game.currentScene as Location;
    scene.roomTileMap.changeTileColor(Color.fromHex(color));
  }

  get hasRoomPermission() {
    const authenticatedUserId = parseInt(
      localStorage.getItem("tam_user_id") as string,
      10
    );
    return hasRole("admin") || this.ownerId === authenticatedUserId;
  }

  render() {
    return html`
      <div class="location_info">
        <chat-history></chat-history>

        <div
          class="location_info__header"
        >
          <div class="location_info__details">
            <strong>${this.title}</strong>
            <span>Owner: ${this.owner}</span>
          </div>
          <span
            class="label circle"
          >
            ${this.usersInRoom}
          </span>
        </div>
        ${
          this.isEditing
            ? html`
                <div class="carousel">
                  <p class="label">Wall:</p>
                  <div class="patterns" style="display: flex;">
                    ${WALL_PATTERNS.map(
                      (pattern) => html`
                        <div
                          class="navigator_location"
                          style="padding: 6px; overflow: hidden; cursor: pointer;"
                        >
                          <button
                            class="pattern-button"
                            style="width: 20px; background-image: url('/public/wall/${pattern}'); border: 0; border-radius: 5px;"
                            @click="${() => this.setWallPattern(pattern)}"
                          >
                            <span style="visibility: hidden;">${pattern}</span>
                          </button>
                        </div>
                      `
                    )}
                  </div>
                  <p class="label">Floor</p>
                  <div class="colors">
                    ${this.tileColors.map(
                      (color) => html`
                        <button
                          class="color-button ${this.selectedTileColor === color
                            ? "is-active"
                            : ""}"
                          style="background-color: #${color};"
                          @click="${() => this.setTileColor(color)}"
                        >
                          <span>${color}</span>
                        </button>
                      `
                    )}
                  </div>

                  <button class="btn">Save</button>
                </div>
              `
            : html`
                <div class="furni_viewer__button-group">
                  ${this.hasRoomPermission
                    ? html`
                        <button class="btn" @click="${this.openEditMode}">
                          Customize room
                        </button>

                        <button class="btn" @click="${this.openRoomSettings}">
                          Room settings
                        </button>
                      `
                    : ""}
                </div>
              `
        }
      </div>
    `;
  }
}
